import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {styled} from '@linaria/react';
import React from 'react';
import {AddToBasketActionButton} from './AddToBasketActionButton';
import {AddToWishlistButton} from './AddToWishlistButton';
import {ShareButton} from './ShareButton';
import {useShareBtnText} from './useShareBtnText';

const ProductShareButton: React.FC<{
  shareUrl: string;
  productPath: string;
}> = ({shareUrl, productPath}) => {
  const shareBtnText = useShareBtnText(shareUrl, productPath);
  return <StyledShareButton text={shareBtnText} />;
};

const StyledShareButton = styled(ShareButton)`
  margin-right: -16px;
  margin-top: -12px;
`;

export const CTAs: React.FC<{
  product: Product;
  price?: Price;
  brand: Brand;
  onAddToBasketIconClick: () => void;
  isAddToBasketInView: boolean;
  isAddToBasketLoading: boolean;
  hideAddToBasketButton?: boolean;
  className?: string;
  style?: React.CSSProperties;
  badgesListKeys: string[];
}> = ({
  product,
  price,
  brand,
  onAddToBasketIconClick,
  isAddToBasketInView,
  isAddToBasketLoading,
  hideAddToBasketButton = false,
  className,
  style,
  badgesListKeys,
}) => {
  return (
    <Container className={className} style={style}>
      <PointerAuto>
        <ProductShareButton
          shareUrl={product.shareUrl}
          productPath={product.path}
        />
      </PointerAuto>
      <div>
        {!hideAddToBasketButton && (
          <AddToBasketActionButton
            isAddToBasketInView={isAddToBasketInView}
            isLoading={isAddToBasketLoading}
            onClick={onAddToBasketIconClick}
          />
        )}
        <PointerAuto>
          <AddToWishlistButton
            product={product}
            brand={brand}
            price={price}
            badgesListKeys={badgesListKeys}
          />
        </PointerAuto>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin: 20px;
  margin-top: 16px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
`;

const PointerAuto = styled.div`
  pointer-events: auto;
`;
